'use client';

import { useLocale } from 'next-intl';
import { useState } from 'react';
import { ListingCard } from '~/components/ListingCard';
import { Markdown } from '~/components/Markdown';
import { getPathname } from '~/i18n/navigation';
import { api } from '~/libs/api';
import { trackBlueprintClicked } from '~/utils';
import styles from './TripCard.module.css';
import type { VirtualBlueprintCardProps } from './TripCard.types';
import { TripCardFooter } from './TripCardFooter';
import { TripCardPlaces } from './TripCardPlaces';
const VirtualBlueprintCard = ({
  trip
}: VirtualBlueprintCardProps) => {
  const {
    image,
    virtualBlueprintString,
    description,
    places
  } = trip;
  const title = 'title' in trip ? trip.title as string : '';
  const locale = useLocale();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const virtualBlueprintJourneyUrl = api.virtualBlueprint.getVirtualBlueprintJourneyUrl.useMutation();
  const handleClick = async (): Promise<void> => {
    if (isLoading) return;
    setIsLoading(true);
    trackBlueprintClicked({
      blueprintId: trip.id,
      title,
      virtual: true
    });
    try {
      const result = await virtualBlueprintJourneyUrl.mutateAsync({
        virtualBlueprintString: virtualBlueprintString ?? '',
        journeyTitle: title
      });
      const {
        url
      } = result;
      if (!url) {
        setIsLoading(false);
        return;
      }
      globalThis.location.href = getPathname({
        href: url,
        locale
      });
    } catch (_error) {
      setIsLoading(false);
    }
  };
  return <ListingCard variant="trip" isLoading={isLoading} role="link" tabIndex={0} onClick={handleClick} onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  }} aria-label={title}>
      <div className={styles.gallerySlot}>
        <ListingCard.Gallery images={image?.responsiveImage ? [{
        data: image.responsiveImage
      }] : []} />
      </div>
      <ListingCard.Content>
        <div className={styles.tripCardContentInner}>
          <ListingCard.Title as="h3">{title}</ListingCard.Title>
          <TripCardPlaces places={places} />
          {description && <Markdown className={styles.markdown}>{description}</Markdown>}
          <TripCardFooter isLoading={isLoading} />
        </div>
      </ListingCard.Content>
    </ListingCard>;
};
export { VirtualBlueprintCard };